// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/scripts/" + chunkId + "." + "784f842dd41069eb008e" + ".js";
};